import Root from './_Root'
import { format } from 'date-fns'

export default class Review extends Root
    id: ''
    time: ''
    movie_id: ''
    score: ''
    where: ''
    who: ''
    review: ''

    constructor: (original) ->
        super original
        Root.Copy(original, @)
        @time = format(new Date())[0..18] if not @time
